import { sniff, history } from '@/util'
import openWebview from './bridge/openWebview'
import { isObject } from 'lodash'

// 新开webview
const openNewPage = function (url, config, disableInH5 = true) {
  if (sniff.isUboxApp || sniff.isWechatMiniProgram) {
    const _loc = location
    const _url = `${_loc.origin}${url}`
    const webviewConfig = {
      'url': _url,
      'theme': 'light',
      'fullscreen': true,
      'immersed': false,
      ...config,
    }
    openWebview(webviewConfig)
  } else if (disableInH5) {
    isObject(url) ? history.push(url) : history.push(`${url}`)
    // window.location.href = `#${url}`
    scrollTo(0, 0)
  }
}
export default openNewPage